/**
 * Converts FormData into JSON.
 * Can handle duplicated names (puts them as an array of values).
 * You can handle some data explicitly - define second param with map of names.
 * Duplicated names will be placed into the same array.
 * @param {FormData} formData
 * @param {object} valuesToArray (optional) - { nameFromFormData: arrayName }
 * @returns {object} { [key: string]: string|number|Array<string|number> }
 */
export function FormDataToJSON(formData, valuesToArray = {}) {
    return Array.from(formData).reduce((createdObject, currentFormDataEntry) => {
        let key = currentFormDataEntry[0];
        const value = currentFormDataEntry[1];
        // formData name will become the name of an array
        const swapMe = valuesToArray[key];
        if (swapMe) {
            // if exists then swap the name
            key = swapMe;
        }
        // check if the name was seen before
        if (!createdObject[key]) {
            // if swapped than it should be an array even if it's only one
            return { ...createdObject, [key]: swapMe ? [value]: value }
        }
        else {
            return { ...createdObject, [key]: [...createdObject[key], value] }
        }
    }, {});
}


/**
 * Replace params ({0}, {1}...) in string for provided array
 *
 * @param {string} message
 * @param {array} paramsData
 */
export function replaceParamsInString(message, paramsData = []) {
    paramsData.map((param, index) => {
        message = message.replace(`{${index}}`, param);
    });

    return message;
}



export function decodeB64Unicode(str) {
    try {
        return decodeURIComponent(atob(str).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    } catch(e){
        return ''
    }
}
